"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiftDesignLayers = void 0;
exports.default = shiftDesignLayersRight;
const getCoverageType_1 = require("./getCoverageType");
const constants_1 = require("../../utils/constants");
/**
 * Given the x coordinate (in %) calculate the shifted left/right x coordinate
 */
const calculateShiftedXForEpb = (direction, x) => {
  return direction === getCoverageType_1.SpreadSide.RIGHT ? x + 0.5 : x - 0.5;
};
/**
 * Given the x coordinate (in %) and surfaceWidth and bleed (in inches) calculate the shifted left/right x coordinate
 */
const calculateShiftedX = (direction, surfaceWidth, x, bleed) => {
  // This accounts for the fact that a full bleed image well on the right page does not have any bleed on its left edge,
  // yet needs to account for bleed when moving to the left page.
  const xNormalized = x >= 0.5 ? x - 0.5 : x;
  const bleedOffset = bleed ? xNormalized * surfaceWidth >= bleed ? bleed : 0 : 0;
  return direction === getCoverageType_1.SpreadSide.RIGHT ? x + 0.5 - bleedOffset / surfaceWidth : x - 0.5 + bleedOffset / surfaceWidth;
};
/* Takes an array of all pre-defined Layers, along with a Design. Returns an array of the layers specified in the design,
     modified to have different IDs and x positions that have been shifted to the right by one-half of the surface. */
function shiftDesignLayersRight(sku, templateLayers, surface) {
  return (0, exports.shiftDesignLayers)(getCoverageType_1.SpreadSide.RIGHT, sku, templateLayers, surface);
}
const shiftDesignLayers = (direction, sku, templateLayers, surface) => {
  return templateLayers.map(dl => {
    const x = sku === 'everyday-photo-book' ? calculateShiftedXForEpb(direction, dl.x) : calculateShiftedX(direction, surface.width, dl.x, Array.isArray(surface.bleed) ? surface.bleed[0] : surface.bleed);
    return Object.assign(Object.assign({}, dl), {
      x,
      id: direction === 'right' ? dl.id + constants_1.SHIFTED_RIGHT_APPENDIX : dl.id.replace(constants_1.SHIFTED_RIGHT_REGEX, '')
    });
  });
};
exports.shiftDesignLayers = shiftDesignLayers;